export * from "ce/pages/Editor/IDE/Header/useLibraryHeaderTitle";
import { default as CE_useLibraryHeaderTitle } from "ce/pages/Editor/IDE/Header/useLibraryHeaderTitle";
export default CE_useLibraryHeaderTitle;
